import React from 'react';

const InsightsContext = React.createContext('reports');

export const InsightsContextProvider = InsightsContext.Provider;

export default InsightsContext;
